export default {
    nameRules: function(_this) {
        return [
            { required: true, message: _this.$t('index.business_cooperation_form_placeholder_name'), trigger: 'blur' },
            { min: 2, max: 50, message: 'Format error', trigger: ['blur', 'change'] },
            { validator: validateName, trigger: ['blur', 'change'] }
        ];
    },
    phoneRules: function(_this) {
        return [
            { required: true, message: _this.$t('index.business_cooperation_form_placeholder_phone'), trigger: 'blur' },
            { min: 5, max: 30, message: 'Format error', trigger: ['blur', 'change'] },
            { validator: validatePhoneNumber, trigger: ['blur', 'change'] }
        ];
    },
    companyRules: function(_this) {
        return [
            { required: true, message: _this.$t('index.business_cooperation_form_placeholder_company'), trigger: 'blur' },
            { min: 5, max: 120, message: 'Format error', trigger: ['blur', 'change'] },
            { validator: validateCompany, trigger: ['blur', 'change'] }
        ];
    },
    emailRules: function(_this) {
        return [
            { required: true, message: _this.$t('index.business_cooperation_form_placeholder_email'), trigger: 'blur' },
            { type: 'email', message: 'Email format error', trigger: ['blur', 'change'] }
        ];
    }
};

// 验证姓名
function validateName(rule, value, callback)
{
    // 姓名只能包含英文和中文
    const reg = /^[a-zA-Z\u4e00-\u9fa5\s]+$/;
    if(value && !reg.test(value))
    {
        callback(new Error('Format error'));
    }
    else
    {
        callback();
    }
}

// 验证手机号
function validatePhoneNumber(rule, value, callback)
{
    // 手机号只能包含数字和空格（+号）
    const phoneNumberRegex = /^[0-9\s]+$/;
    if(!phoneNumberRegex.test(value))
    {
        callback(new Error('Format error'));
    }
    else
    {
        callback();
    }
}

// 验证公司名称
function validateCompany(rule, value, callback)
{
    // 公司名称只能包含中文、英文（大小写）、数字、空格
    const companyNameRegex = /^[\u4e00-\u9fa5a-zA-Z0-9\s]+$/;
    if(!companyNameRegex.test(value))
    {
        callback(new Error('Format error'));
    }
    else
    {
        callback();
    }
}
